const ITEMS = [
  "18K Gold Finish",
  "Botanical Motifs",
  "Consciously Crafted",
  "Purple Amethyst",
  "Sterling Silver",
  "Heirloom Silhouettes",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {[...ITEMS, ...ITEMS].map((item, i) => (
      <span key={i} className="flex items-center whitespace-nowrap font-serif text-xl italic text-ink/80 md:text-2xl">
        <span className="px-6">{item}</span>
        <span className="text-sm not-italic text-gold">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-borderline bg-sand py-5"
    data-testid="marquee-strip"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Strip />
      <Strip />
    </div>
  </div>
);
